/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import {Button} from "antd";
import styles from './PeriodButtons.module.scss';
import {RankingPeriodType} from "../PointAdjust.interface";
import {PointPeriodType} from "../../../types/Type";

interface ButtonsProps {
	selectedPointPeriod: PointPeriodType;
	selectedRankingPeriod?: RankingPeriodType;
	onClick: (period: RankingPeriodType) => any;
}

const PeriodButtons = ({selectedPointPeriod, selectedRankingPeriod, onClick}: ButtonsProps) => {
	const getClassName = (rankingPeriodType: RankingPeriodType) => selectedRankingPeriod === rankingPeriodType ? styles.selected : '';

	return (
		<div className={styles.wrap}>
			{selectedPointPeriod === 'all_time' && (
				<Button className={getClassName('all_time')} onClick={() => {}}>전체 누적</Button>
			)}
			{selectedPointPeriod === 'month' && (
				<>
					<Button className={getClassName('this_month')} onClick={() => onClick('this_month')}>이번달 순위</Button>
					<Button className={getClassName('next_month')} onClick={() => onClick('next_month')}>다음달 순위</Button>
				</>
			)}
			{selectedPointPeriod === 'half_month' && (
				<>
					<Button className={getClassName('this_half_month')} onClick={() => onClick('this_half_month')}>이번 반월 순위</Button>
					<Button className={getClassName('next_half_month')} onClick={() => onClick('next_half_month')}>다음 반월 순위</Button>
				</>
			)}
			{(selectedPointPeriod === 'last30' || selectedPointPeriod === 'last60' || selectedPointPeriod === 'last90') && (
				<>
					<Button className={getClassName('last30')} onClick={() => onClick('last30')}>최근30일</Button>
					<Button className={getClassName('last60')} onClick={() => onClick('last60')}>최근60일</Button>
					<Button className={getClassName('last90')} onClick={() => onClick('last90')}>최근90일</Button>
				</>
			)}
		</div>
	);
}

export default PeriodButtons;
